import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "color-code" }, "Kód", -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "color-shade" }, "Odtieň", -1)
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "color-hash" }, "Farba #", -1)
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "flex align-items-center justify-content-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "imitation",
  class: "ml-2"
}, "Imitácia dreva", -1)
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Popis", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_15 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueTextArea = _resolveComponent("PrimevueTextArea")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-6 md:w-6 lg:w-5 xl:w-4" }, {
      title: _withCtx(() => [
        _createTextVNode("FARBA")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "colorForm"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: _normalizeClass(["w-full", `${$setup.v$.color.code.$error ? 'bg-red-200' : ''}`]),
              invalid: $setup.v$.color.code.$error,
              modelValue: this.color.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.color.code) = $event)),
              type: "text",
              name: "color-code",
              id: "color-code"
            }, null, 8, ["class", "invalid", "modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.color.code.$errors, (error, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "text-sm font-italic text-red-400"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              class: "w-full",
              modelValue: this.color.shade,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.color.shade) = $event)),
              type: "text",
              name: "color-shade",
              id: "color-shade"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              class: "w-full",
              modelValue: this.color.colorHash,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.color.colorHash) = $event)),
              type: "text",
              name: "color-hash",
              id: "color-hash"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_PrimevueCheckbox, {
                modelValue: this.color.imitation,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.color.imitation) = $event)),
                inputId: "imitation",
                name: "imitation",
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_PrimevueTextArea, {
              autoResize: "",
              rows: "1",
              class: "w-full",
              placeholder: "Tu napíš popis k farbe",
              modelValue: this.color.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.color.description) = $event)),
              style: {"text-align":"left"},
              name: "description",
              id: "description"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Uložiť",
              text: "",
              raised: "",
              class: "uppercase"
            }),
            _createVNode(_component_router_link, { to: "/mod-stock/colors" }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimevueButton, {
                  label: "Zrušiť",
                  severity: "danger",
                  text: "",
                  raised: "",
                  class: "uppercase"
                })
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}